import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../../utils/axiosInstance';
import DeleteProducts from './DeleteProducts';

const UpdateProduct = () => {

  const navigate= useNavigate()
  const { id } = useParams();
  const [product, setProduct] = useState({
    name: '',
    price: '',
    description: '',
    image: '',
    unit: '',
    ingredients: '',
    addedAt: '',
    originalprice: '',
    discountprice: '',
  });
  const [editedProduct, setEditedProduct] = useState({
    name: '',
    price: '',
    description: '',
    image: null, // Use null for the file object
    unit: '',
    ingredients: '',
    addedAt: '',
    originalprice: '',
    discountprice: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axiosInstance.get(`/api/products/get-product/${id}`);
        setProduct(response.data);
        setEditedProduct(response.data); // Initialize editedProduct with current values
        setLoading(false);
      } catch (error) {
        console.error('Error fetching product:', error);
      }
    };

    fetchProduct();
  }, [id]);

  const handleInputChange = (fieldName, value) => {
    setEditedProduct((prevEditedProduct) => ({
      ...prevEditedProduct,
      [fieldName]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setEditedProduct((prevEditedProduct) => ({
      ...prevEditedProduct,
      image: file,
    }));
  };



  const handleDeleteSuccess= async () =>{
      
    navigate("/admin/products")
  }

  const handleUpdate = async () => {
    try {
      const token = localStorage.getItem('admintoken');

      const formData = new FormData();
      formData.append('name', editedProduct.name);
      formData.append('price', editedProduct.price);
      formData.append('description', editedProduct.description);
      formData.append('image', editedProduct.image);
      formData.append('unit', editedProduct.unit);
      formData.append('ingredients', editedProduct.ingredients);
      formData.append('category', editedProduct.category);
      formData.append('originalprice', editedProduct.originalprice);
      formData.append('discountprice', editedProduct.discountprice);
      
      const response = await axiosInstance.put(
        `/api/products/update-products/${id}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            token: `Bearer ${token}`,
          },
        }
      );

      // Handle the response as needed
      console.log('Product updated:', response.data);

      // Optionally, you can update the UI or redirect to another page after a successful update
    } catch (error) {
      console.error('Error updating product:', error);
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="bg-white p-6 shadow-md rounded-md mt-20 max-w-md mx-auto">
      <div className="bg-gray-800 py-2 px-4 rounded-md">
      <ul className="flex text-white">
        <li className="mr-2">
          <Link to="/admin/home" className="hover:text-amber-500 transition">
            Home
          </Link>
        </li>
        <li className="mr-2">/</li>
        <li className="mr-2">
          <Link to="/products" className="hover:text-amber-500 transition">
            Products
          </Link>
        </li>
      </ul>
    </div>
    <p className="text-xl font-semibold mb-4">Update Product</p>
     Added At:{new Date(product.addedAt).toLocaleDateString()}
      <div className=" lg:absolute left-2/3" >
    <img
      src={`${axiosInstance.defaults.baseURL}/${product.image}`}
      alt={product.name}
      className="w-full h-40 object-cover mb-4 rounded"
    />

      </div>
    <div className="flex flex-col space-y-4">
      <label htmlFor=""> Cake Name</label>
      <input
        type="text"
        name="name"
        value={editedProduct.name}
        onChange={(e) => handleInputChange('name', e.target.value)}
        placeholder="Product Name"
        className="p-2 border rounded focus:outline-none focus:border-blue-500"
      />
            <label htmlFor=""> Cake Price</label>

      <input
        type="text"
        name="price"
        value={editedProduct.price}
        onChange={(e) => handleInputChange('price', e.target.value)}
        placeholder="Price"
        className="p-2 border rounded focus:outline-none focus:border-blue-500"
      />
      {editedProduct.isspecial && (
  <>
    <label htmlFor="">Original Price</label>
    <input
      type="text"
      name="originalprice"
      value={editedProduct.originalprice}
      onChange={(e) => handleInputChange('originalprice', e.target.value)}
      placeholder="Original Price"
      className="p-2 border rounded focus:outline-none focus:border-blue-500"
    />

    <label htmlFor="">Discount Price</label>
    <input
      type="text"
      name="discountprice"
      value={editedProduct.discountprice}
      onChange={(e) => handleInputChange('discountprice', e.target.value)}
      placeholder="Discount Price"
      className="p-2 border rounded focus:outline-none focus:border-blue-500"
    />
  </>
)}
            <label htmlFor=""> Cake Description</label>

      <input
        type="text"
        name="description"
        value={editedProduct.description}
        onChange={(e) => handleInputChange('description', e.target.value)}
        placeholder="Description"
        className="p-2 border rounded focus:outline-none focus:border-blue-500"
      />
            <label htmlFor=""> Cake Unit</label>

      <input
        type="text"
        name="unit"
        value={editedProduct.unit}
        onChange={(e) => handleInputChange('unit', e.target.value)}
        placeholder="unit"
        className="p-2 border rounded focus:outline-none focus:border-blue-500"
      />
            <label htmlFor=""> Cake Ingredients</label>

      <input
        type="text"
        name="ingredients"
        value={editedProduct.ingredients}
        onChange={(e) => handleInputChange('ingredients', e.target.value)}
        placeholder="Ingredients"
        className="p-2 border rounded focus:outline-none focus:border-blue-500"
      />

            <label htmlFor=""> Cake Category</label>

      <input
        type="text"
        name="category"
        value={editedProduct.category}
        onChange={(e) => handleInputChange('category', e.target.value)}
        placeholder="Categgory"
        className="p-2 border rounded focus:outline-none focus:border-blue-500"
      />
    

      <div className="flex items-center space-x-2">
        <label htmlFor="image" className="text-lg font-bold">Image:</label>
        <input
          type="file"
          name="image"
          id="image"
          onChange={handleFileChange}
          className="p-2 border rounded focus:outline-none focus:border-blue-500"
        />
      </div>
    </div>
    <button onClick={handleUpdate} className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700">
      Update
    </button>


    <div className="bg-red-500 text-white py-2 px-4 rounded hover:bg-blue-700 mt-2 w-24 ">

    <DeleteProducts className="ml-14" id={id} onDeleteSuccess={handleDeleteSuccess} />
    </div>

  </div>
  
  );
};

export default UpdateProduct;
